interface Props {
  color?: string;
  width?: number;
  height?: number;
}

const CopyLink = ({ width = 16, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_398_2597"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path
          d="M3.5 2.72262V1.625C3.5 1.32663 3.61853 1.04048 3.8295 0.829505C4.04048 0.618526 4.32663 0.5 4.625 0.5H14.375C14.6734 0.5 14.9595 0.618526 15.1705 0.829505C15.3815 1.04048 15.5 1.32663 15.5 1.625V11.375C15.5 11.6734 15.3815 11.9595 15.1705 12.1705C14.9595 12.3815 14.6734 12.5 14.375 12.5H13.2564"
          stroke="white"
        />
        <path
          d="M12.125 2.75H1.625C1.00368 2.75 0.5 3.25368 0.5 3.875V14.375C0.5 14.9963 1.00368 15.5 1.625 15.5H12.125C12.7463 15.5 13.25 14.9963 13.25 14.375V3.875C13.25 3.25368 12.7463 2.75 12.125 2.75Z"
          fill="white"
          stroke="white"
          strokeLinejoin="round"
        />
        <path
          d="M5.91497 7.66595L7.89947 5.5997C8.4436 5.05558 9.33835 5.0672 9.89747 5.6267C10.4566 6.1862 10.4686 7.08058 9.92447 7.6247L9.20822 8.38333M4.04972 9.77983C3.85847 9.97108 3.46285 10.3536 3.46285 10.3536C2.91835 10.8977 2.90335 11.8678 3.46285 12.4273C4.0216 12.9861 4.91635 12.9985 5.46085 12.454L7.39735 10.696"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99853 9.623C5.74934 9.37556 5.5986 9.04596 5.5744 8.69562C5.56016 8.49912 5.58828 8.30184 5.65686 8.11714C5.72543 7.93243 5.83287 7.7646 5.9719 7.625M7.37028 8.69788C7.9294 9.257 7.9414 10.1518 7.39728 10.6963"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_398_2597)">
        <path d="M-1 -1H17V17H-1V-1Z" fill="#7A869A" />
      </g>
    </svg>
  );
};

export default CopyLink;
